import { route as ziggyRoute } from 'ziggy-js';

type InitialInertiaPage = {
    props?: {
        locale?: string;
        auth?: { user?: { id?: string } | null } | null;
        ziggy?: unknown;
        trackingEvents?: unknown;
    };
};

export function readInitialInertiaPage(): InitialInertiaPage {
    const script = document.querySelector('script[data-page]');

    if (!script?.textContent) {
        return {};
    }

    try {
        return JSON.parse(script.textContent) as InitialInertiaPage;
    } catch {
        return {};
    }
}

export function assignWindowZiggy(ziggy: unknown): void {
    if (!ziggy) {
        return;
    }

    const browserWindow = window as unknown as {
        Ziggy: unknown;
        route: typeof ziggyRoute;
    };

    browserWindow.Ziggy = ziggy;
    browserWindow.route = ziggyRoute;
}
